import { defineComponent as _defineComponent } from 'vue'
import isString from 'lodash/isString';
import { computed } from 'vue';
import { useRoute } from 'vue-router/composables';

import NodeEditor from '../NodeEditor.vue';
import SetupEditorPanel from '../SetupEditorPanel.vue';
import ShrinkButton from '../drawers/ShrinkButton.vue';
import WidgetBlockEditor from '@/components/BlockEditor/WidgetBlockEditor.vue';
import { TRIGGER_EDITOR_ROUTE_NAME } from '@/router/router.const';
import {
	useNodesGetters,
	useSelectedWorkflowGetters,
	useWorkflowsGetters,
	useLeftSideDrawerActions,
	useLeftSideDrawerGetters,
} from '@/store-composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'RightSidePanel',
  props: {
    nodeId: null
  },
  emits: ["closeSideBar"],
  setup(__props: any, { emit }: { emit: ({ (e: 'closeSideBar'): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { nodeId?: /*WorkflowNodeId*/ number | string }



const { isLeftSideDrawerOpen } = useLeftSideDrawerGetters();
const { isWidget, isEndRunWidget } = useNodesGetters();
const isWidgetNode = computed(
	() => !!props.nodeId && !isString(props.nodeId) && (isWidget.value(props.nodeId) || isEndRunWidget.value(props.nodeId))
);
const route = useRoute();
const isTriggerEditor = computed(() => route.name === TRIGGER_EDITOR_ROUTE_NAME);
const showNodeEditor = computed(() => (!!props.nodeId || isTriggerEditor.value) && !(isWidgetNode.value || isLeftSideDrawerOpen.value));
const { canEditWorkflow } = useWorkflowsGetters();
const { selectedWorkflowId } = useSelectedWorkflowGetters();
const hasEditPermissions = computed(() => !!selectedWorkflowId.value && canEditWorkflow.value(selectedWorkflowId.value));
const { clearLeftSideBar } = useLeftSideDrawerActions();

return { __sfc: true,props, emit, isLeftSideDrawerOpen, isWidget, isEndRunWidget, isWidgetNode, route, isTriggerEditor, showNodeEditor, canEditWorkflow, selectedWorkflowId, hasEditPermissions, clearLeftSideBar, NodeEditor, SetupEditorPanel, ShrinkButton, WidgetBlockEditor }
}

})